module.exports = __webpack_public_path__ + "static/img/13.da3b9b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/eng/13.png
// module id = cw2X
// module chunks = 0